module.exports = __webpack_public_path__ + "img/12.cd5808ff.svg";